// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WVQJs","largestCol":"styles_largestCol__1ajdl","smallestCol":"styles_smallestCol__3mku9"};